module.exports = __webpack_public_path__ + "624c1255/img/45000000-7.dd3ac6fe.png";